import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConsultarCiudadano } from '../models/consultarCiudadano.model';
import { environment } from '../../../../environments/environment';

const headers: any = new HttpHeaders({
  'Content-Type': 'application/json'
});

@Injectable({
  providedIn: 'root'
})

export class BrokervService
{
  datos: any;
  boton: any;
  datosValidado: any;
  reportSelected: any;
  nameNotifica: any;
  nameCon: any;
  precio: any;

  constructor(public http: HttpClient) { 

  }

  validar_sesion(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.validationSession, body, { headers });
  }

  cerrar_sesion(cookie:any){
    const body = {
      clientId: environment.oktaConfig.clientId,
      country: environment.country,
      idSession: cookie,
    };
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.signOff, body, { headers });
  }

  consultarCiudadano(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.consultaCiudadano, body, {headers});
  }

  responderSolicitud(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.responderSolicitud, body, {headers});
  }

  consultarHistorico(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.consultarHistorico, body, {headers});
  }

  consultarPrecio(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.consultarPrecio, body, {headers});
  }

  redimirPromo(body:any){
    return this.http.post(environment.APIEndPoints.urlEndPoints + environment.verifica.redimirPromo, body, {headers});
  }
}